/**
 * Fred Olsen Cruise Lines Dynamica LTT API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface WorkflowRunInfo { 
    status?: WorkflowRunInfo.StatusEnum;
    lastSuccessfulTimestamp?: string;
}
export namespace WorkflowRunInfo {
    export const StatusEnum = {
        NeverRun: 'NEVER_RUN',
        Running: 'RUNNING',
        Successful: 'SUCCESSFUL',
        Failed: 'FAILED'
    } as const;
    export type StatusEnum = typeof StatusEnum[keyof typeof StatusEnum];
}


